import {
  addNavMenuItem,
  registerBulkAction,
} from "@bb-vendure/admin-ui/core";
import { deleteBulkAction } from "./components/bulkAction";
export default [
  addNavMenuItem(
    {
      id: "shop-supplier",
      label: "nav.supplier",
      routerLink: ["/extensions/supplier"],
      icon: "container",
      requiresPermission: (userPermissions) =>
        userPermissions.includes('ReadSupplier'),
    },
    "products-section"
  ),

  registerBulkAction(deleteBulkAction),

  // registerFormInputComponent(
  //   "shop-supplier-dropdown",
  //   ShopSupplierDropdownComponent
  // ),

  // registerDataTableComponent({
  //   component: ProductTypeColumnComponent,
  //   tableId: "product-list",
  //   columnId: "productType",
  // }),
];
